import React, { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";

const KEY = "hse_cookie_consent_v1";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem(KEY)) setVisible(true);
    }, 800);
    return () => clearTimeout(t);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    setVisible(false);
  };
  const decline = () => {
    localStorage.setItem(KEY, "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-md z-[60] border border-[#2FA36B]/60 bg-[#0F2A44] backdrop-blur-xl shadow-2xl"
    >
      <div className="p-5">
        <div className="flex items-start gap-3 mb-3">
          <div className="w-9 h-9 bg-[#2FA36B] flex items-center justify-center shrink-0">
            <Cookie size={18} className="text-white" />
          </div>
          <div className="flex-1">
            <p className="font-condensed uppercase text-xs tracking-[0.25em] text-[#2FA36B] font-bold">Cookies & LGPD</p>
            <h3 className="font-condensed font-bold text-white text-base leading-tight">Sua privacidade é importante</h3>
          </div>
          <button
            aria-label="Fechar"
            onClick={decline}
            data-testid="cookie-close"
            className="text-white/50 hover:text-white p-1"
          >
            <X size={16} />
          </button>
        </div>
        <p className="font-body text-xs text-white/70 leading-relaxed mb-4">
          Utilizamos cookies essenciais e de análise para melhorar sua experiência no site da HSE. Ao continuar, você concorda com nossa{" "}
          <a href="/politica-de-privacidade" data-testid="cookie-policy-link" className="text-[#2FA36B] underline">
            Política de Privacidade
          </a>{" "}
          e com o tratamento de dados conforme a LGPD.
        </p>
        <div className="flex gap-2">
          <button
            onClick={accept}
            data-testid="cookie-accept"
            className="flex-1 font-condensed uppercase text-[11px] tracking-[0.2em] font-bold bg-[#2FA36B] hover:bg-[#37B87A] text-white px-4 py-3 transition-colors"
          >
            Aceitar todos
          </button>
          <button
            onClick={decline}
            data-testid="cookie-decline"
            className="flex-1 font-condensed uppercase text-[11px] tracking-[0.2em] font-bold border border-white/20 hover:border-white text-white px-4 py-3 transition-colors"
          >
            Rejeitar
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
